<template>
	<div :class="{ full, small }">
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 98 98"
			style="enable-background:new 0 0 98 98;"
			xml:space="preserve"
		>
			<g id="Desktop">
				<g id="Desktop_Product_Page-Copy-12" transform="translate(-874.000000, -609.000000)">
					<g id="Group-70-Copy" transform="translate(874.000000, 609.000000)">
						<g id="logo-text">
							<path
								id="Fill-1"
								class="st0"
								d="M36.3,10.3c-1.5,0.5-2.7,0.1-3.3-1.7l1.4-0.5c0.3,0.8,0.7,1.3,1.5,1c0.6-0.2,1-0.7,0.8-1.5
					c-0.2-0.6-0.7-0.7-1.6-0.7l-0.6,0c-1,0-2-0.3-2.4-1.5c-0.6-1.7,0.4-2.7,1.7-3.1c1.4-0.4,2.6-0.2,3.1,1.4l-1.4,0.5
					c-0.3-0.6-0.6-1-1.3-0.8c-0.6,0.2-0.8,0.6-0.6,1.3c0.2,0.6,0.7,0.7,1.5,0.7l0.6,0c1.1,0,2.2,0.2,2.6,1.5
					C38.8,8.7,37.7,9.8,36.3,10.3"
							/>
							<polygon id="Fill-3" class="st0" points="42.8,1.7 43.8,8.4 42.3,8.6 41.3,1.9 39.3,2.2 39.1,1 44.6,0.2 44.8,1.4 				" />
							<polygon id="Fill-5" class="st0" points="50.7,5.1 50.6,8.1 49.1,8.1 49.2,5.1 46.9,0 48.8,0 50,3.7 51.5,0.1 53.2,0.1 				" />
							<polygon id="Fill-7" class="st0" points="54.5,8.4 56,0.5 57.5,0.8 56.2,7.5 59.9,8.2 59.6,9.4 				" />
							<polygon
								id="Fill-9"
								class="st0"
								points="61.1,9.9 63.9,2.3 68.6,4.1 68.2,5.3 64.9,4 64.2,6 67.3,7.2 66.8,8.3 63.7,7.2 
					62.9,9.3 66.3,10.5 65.9,11.7 				"
							/>
							<path
								id="Fill-11"
								class="st0"
								d="M76.7,19.2c-1.2-1.1-1.4-2.3-0.1-3.7l1.1,1c-0.6,0.6-0.8,1.2-0.1,1.8c0.5,0.5,1.1,0.6,1.7,0
					c0.4-0.4,0.3-0.9-0.1-1.7l-0.3-0.6c-0.5-0.9-0.8-1.9,0.2-2.9c1.2-1.3,2.5-0.9,3.5,0c1.1,1,1.4,2.2,0.2,3.4l-1.1-1
					c0.4-0.5,0.6-1,0-1.5c-0.4-0.4-1-0.4-1.4,0.1c-0.4,0.4-0.2,1,0.1,1.6l0.3,0.5c0.5,1,0.9,2-0.1,3C79.2,20.7,77.7,20.2,76.7,19.2"
							/>
							<polygon
								id="Fill-13"
								class="st0"
								points="80,22.4 80.9,21.7 81.9,23 86.5,19.5 85.5,18.2 86.4,17.5 89.3,21.3 88.4,22 
					87.4,20.7 82.8,24.2 83.8,25.5 82.9,26.2 				"
							/>
							<polygon
								id="Fill-15"
								class="st0"
								points="85.6,31.1 90.7,28.5 87.8,29.2 87.4,28.4 89.6,26.4 84.6,29.1 83.9,27.9 91.1,24.2 
					91.9,25.7 89.3,27.9 92.6,27.1 93.4,28.6 86.3,32.3 				"
							/>
							<path
								id="Fill-17"
								class="st0"
								d="M94.1,34L94,33.5l-2.4,0.8l0.1,0.4c0.3,1.1,0.7,1.6,1.7,1.3C94.5,35.6,94.4,34.9,94.1,34
					 M90.8,35.6l-0.3-1l-3,1L87,34.1l7.7-2.5l0.7,2.2c0.5,1.5,0.5,2.9-1.5,3.6C92.1,38,91.2,36.9,90.8,35.6"
							/>
							<polygon id="Fill-19" class="st0" points="88.9,40.9 96.9,39.7 97.1,41.2 90.4,42.2 90.9,45.9 89.7,46.1 				" />
							<g id="Group-23" transform="translate(89.090909, 47.310985)">
								<g id="Clip-22"></g>
								<defs>
									<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0.5" y="0.3" width="8.2" height="5">
										<feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
									</filter>
								</defs>
								<mask maskUnits="userSpaceOnUse" x="0.5" y="0.3" width="8.2" height="5" id="mask-2_1_">
									<g class="st1">
										<polygon id="path-1_1_" class="st2" points="0.5,0.3 8.7,0.3 8.7,5.3 0.5,5.3 							" />
									</g>
								</mask>
								<polygon
									id="Fill-21"
									class="st3"
									points="0.6,0.3 1.8,0.3 1.7,2 7.5,2.1 7.5,0.5 8.7,0.5 8.5,5.3 7.4,5.3 7.4,3.6 1.7,3.5 
						1.7,5.1 0.5,5.1 					"
								/>
							</g>
							<path
								id="Fill-24"
								class="st0"
								d="M88.7,57c0.4-2.2,2.1-2.5,4.7-2c2.4,0.5,4,1.4,3.5,3.7c-0.3,1.6-1.2,2.2-3,2.1l0.3-1.5
					c0.7,0.1,1.4,0,1.5-0.8c0.2-0.9-0.7-1.5-2.5-1.8c-2.3-0.5-3.1-0.2-3.3,0.6c-0.2,0.8,0.5,1.2,1.3,1.4l-0.3,1.6
					C89.1,59.7,88.4,58.6,88.7,57"
							/>
							<polygon
								id="Fill-26"
								class="st0"
								points="87.8,61.2 88.9,61.6 88.3,63.1 93.7,65.2 94.3,63.6 95.4,64.1 93.6,68.6 92.6,68.1 
					93.2,66.6 87.8,64.5 87.2,66.1 86.1,65.7 				"
							/>
							<polygon
								id="Fill-28"
								class="st0"
								points="89.5,73.7 83.6,70.2 84.4,69 90.3,72.4 91.3,70.7 92.4,71.3 89.5,76.1 88.5,75.5 				
					"
							/>
							<polygon
								id="Fill-30"
								class="st0"
								points="81.8,77.7 79.5,75.8 80.5,74.6 82.8,76.6 88.2,78 87,79.5 83.3,78.1 85.2,81.5 
					84.1,82.8 				"
							/>
							<polygon
								id="Fill-32"
								class="st0"
								points="71.4,90.8 70.4,88.9 67.4,90.4 66.9,89.3 69.8,87.8 68.3,84.8 69.6,84.1 73.3,91.2 
					68.8,93.5 68.3,92.4 				"
							/>
							<path
								id="Fill-34"
								class="st0"
								d="M61.1,87.6c1.8-0.6,2.7,0.2,3.2,1.9l1.6,5.1l-1.4,0.4l-1.6-5c-0.3-0.9-0.6-1.7-1.6-1.4
					c-0.9,0.3-0.7,1.2-0.5,2l1.6,5l-1.4,0.4L59.6,91C59,89.2,59.4,88.1,61.1,87.6"
							/>
							<polygon
								id="Fill-36"
								class="st0"
								points="54.1,89.3 56.4,95.2 55.5,89.1 56.9,88.9 58,96.9 55.9,97.2 53.7,91.3 54.5,97.4 
					53.2,97.5 52.1,89.6 				"
							/>
							<g id="Group-40" transform="translate(44.545455, 88.886742)">
								<g id="Clip-39"></g>
								<defs>
									<filter id="Adobe_OpacityMaskFilter_1_" filterUnits="userSpaceOnUse" x="0" y="0.5" width="5.6" height="8.4">
										<feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
									</filter>
								</defs>
								<mask maskUnits="userSpaceOnUse" x="0" y="0.5" width="5.6" height="8.4" id="mask-4_1_">
									<g class="st4">
										<polygon id="path-3_1_" class="st2" points="0,0.5 5.7,0.5 5.7,8.9 0,8.9 							" />
									</g>
								</mask>
								<path
									id="Fill-38"
									class="st5"
									d="M2.9,0.5c2.3,0.1,2.8,1.7,2.7,4.3C5.6,7.2,4.9,9,2.6,8.9C0.9,8.9,0.2,8,0,6.2l1.6,0
						c0,0.7,0.3,1.4,1.1,1.4c0.9,0,1.3-0.9,1.4-2.8c0.1-2.3-0.3-3.1-1.2-3.1c-0.8,0-1.1,0.7-1.2,1.5l-1.6,0C0.3,1.4,1.2,0.5,2.9,0.5
						"
								/>
							</g>
							<polygon
								id="Fill-41"
								class="st0"
								points="38.7,95.3 40.1,88.7 41.5,89 40.2,95.6 42.2,96.1 41.9,97.3 36.5,96.1 36.7,94.9 				
					"
							/>
							<polygon
								id="Fill-43"
								class="st0"
								points="36.4,87.7 36,88.8 34.5,88.2 32.4,93.6 34,94.2 33.5,95.3 29.1,93.5 29.5,92.4 31,93 
					33.1,87.7 31.5,87.1 32,86 				"
							/>
							<path
								id="Fill-45"
								class="st0"
								d="M24.5,89.9c0.9,0.5,1.6-0.5,2.5-2c1-1.7,1.3-2.6,0.5-3.1c-0.9-0.5-1.5,0.3-2.5,1.9
					C24,88.3,23.6,89.3,24.5,89.9 M28.2,83.8c2,1.2,1.4,2.9,0.2,4.9c-1.3,2.1-2.6,3.4-4.5,2.2c-2-1.2-1.5-2.8-0.2-5
					C24.8,83.9,26.1,82.5,28.2,83.8"
							/>
							<polygon
								id="Fill-47"
								class="st0"
								points="22.2,79.6 19.3,85.2 23.3,80.6 24.3,81.4 19,87.5 17.5,86.2 20.4,80.6 16.4,85.3 
					15.4,84.4 20.6,78.3 				"
							/>
							<path
								id="Fill-49"
								class="st0"
								d="M6.7,71l0.2,0.3l5.1-2.6l-0.1-0.3c-0.6-1.2-1.6-1.2-3.4-0.3C6.6,69.1,6.1,69.9,6.7,71
					 M12.8,67.8l0.8,1.7l-7.2,3.7l-0.9-1.7c-1.1-2.1-0.4-3.4,2.1-4.7C10.2,65.5,11.7,65.7,12.8,67.8"
							/>
							<polygon
								id="Fill-51"
								class="st0"
								points="10.7,63.3 9.6,63.6 9.1,62 3.6,63.7 4.1,65.3 3,65.7 1.6,61.1 2.7,60.7 3.2,62.3 
					8.7,60.6 8.2,59 9.3,58.7 				"
							/>
							<path
								id="Fill-53"
								class="st0"
								d="M8.7,54.4c0.2,1.6-0.3,2.7-2.2,3l-0.2-1.5c0.8-0.1,1.4-0.5,1.3-1.3c-0.1-0.7-0.5-1.2-1.3-1
					c-0.6,0.1-0.8,0.5-1,1.4L5,55.5c-0.2,1-0.6,1.9-1.9,2.1c-1.8,0.2-2.5-0.9-2.7-2.3c-0.2-1.4,0.3-2.6,2-2.8L2.6,54
					c-0.7,0.2-1.1,0.4-1,1.2C1.6,55.8,2,56.1,2.7,56c0.6-0.1,0.8-0.6,1-1.3l0.1-0.6c0.2-1.1,0.6-2.1,2-2.3
					C7.6,51.6,8.5,52.9,8.7,54.4"
							/>
							<g id="Group-57" transform="translate(0.000000, 44.341288)">
								<g id="Clip-56"></g>
								<defs>
									<filter id="Adobe_OpacityMaskFilter_2_" filterUnits="userSpaceOnUse" x="0" y="0" width="8.4" height="5.6">
										<feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
									</filter>
								</defs>
								<mask maskUnits="userSpaceOnUse" x="0" y="0" width="8.4" height="5.6" id="mask-6_1_">
									<g class="st6">
										<polygon id="path-5_1_" class="st2" points="0,0 8.4,0 8.4,5.7 0,5.7 							" />
									</g>
								</mask>
								<path
									id="Fill-55"
									class="st7"
									d="M8.4,2.9C8.3,5.2,6.6,5.7,4.1,5.6C1.7,5.6-0.1,4.9,0,2.5C0.1,0.9,0.9,0.1,2.7,0L2.6,1.6
						c-0.7,0-1.4,0.2-1.4,1.1C1.2,3.6,2.1,4,4,4c2.3,0.1,3.1-0.3,3.1-1.2c0-0.8-0.7-1.1-1.5-1.2l0.1-1.6C7.5,0.3,8.4,1.2,8.4,2.9"
								/>
							</g>
							<path
								id="Fill-58"
								class="st0"
								d="M2.2,39.2c-0.2,1,1,1.4,2.7,1.7c1.9,0.4,2.9,0.4,3.1-0.5c0.2-1-0.8-1.3-2.6-1.7
					C3.5,38.3,2.4,38.2,2.2,39.2 M9.2,40.7c-0.5,2.2-2.3,2.2-4.6,1.8c-2.4-0.5-4-1.4-3.6-3.5c0.5-2.3,2.2-2.3,4.7-1.8
					C7.9,37.6,9.6,38.4,9.2,40.7"
							/>
							<polygon id="Fill-60" class="st0" points="11.3,33.1 10.6,34.9 2.3,34 3,32.4 9.6,33.4 4,29.6 4.6,28.1 				" />
							<polygon
								id="Fill-62"
								class="st0"
								points="12.8,29.9 5.9,25.7 8.5,21.4 9.5,22.1 7.7,25.1 9.5,26.2 11.2,23.3 12.3,24 
					10.6,26.8 12.5,28 14.4,24.9 15.4,25.5 				"
							/>
							<path
								id="Fill-64"
								class="st0"
								d="M12.7,18l-0.5,0.5l1.7,1.5l0.4-0.5c0.5-0.6,0.7-1.3,0.1-1.8C13.8,17.2,13.3,17.3,12.7,18
					L12.7,18z M18.8,21.4c-0.6-0.3-1.1-0.7-1.7-1.1c-0.8-0.6-1.2-0.8-1.9,0l-0.4,0.5l2.6,2.2l-1,1.1l-6.1-5.3l1.4-1.7
					c1-1.2,2.1-1.9,3.4-0.8c0.9,0.7,0.9,1.6,0.4,2.5c1-0.9,1.6-0.5,2.8,0.4c0.5,0.3,0.9,0.6,1.5,0.9L18.8,21.4z"
							/>
							<polygon
								id="Fill-66"
								class="st0"
								points="21.6,14.6 23.5,17 22.4,17.9 20.4,15.6 15.4,13.2 16.9,12 20.2,14 18.9,10.4 
					20.2,9.3 				"
							/>
						</g>
						<path
							id="Fill-68"
							class="st0"
							d="M52.5,25.1h-6.8l-8.8,21.8c0.4,0,0.7,0,1.1,0c2.1,0,4.2,0.2,6.2,0.7l4.7-13.3l8.2,22.7
				c-0.6-0.1-1.3-0.3-1.9-0.5c-1.5-0.5-2.9-1.1-4.2-1.8c-2.5-1.4-5.3-2.5-8.2-3c-1.8-0.4-3.6-0.5-5.5-0.6c-0.7,0-1.4,0-2.1,0.1
				L30,63.6h8.4l2.2-6.1c2.5,0.4,4.9,1.3,7.1,2.5c3.4,1.9,7.3,3.2,11.4,3.5c0,0,0,0,0,0c0.8,0.1,1.5,0.1,2.3,0.1h0h0h6.2L52.5,25.1z
				"
						/>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	props: {
		full: {
			type: Boolean,
			default: true
		},
		small: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.full {
	position: fixed;
	z-index: 9999;
	height: 100vh;
	width: 100vw;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: $brand-white;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		width: 130px;
	}
	#logo-text {
		transform-origin: center;
		animation: logo-text-rotate linear 16000ms infinite;
	}

	@keyframes logo-text-rotate {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
}

.small {
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		width: 130px;
	}
	#logo-text {
		transform-origin: center;
		animation: logo-text-rotate linear 16000ms infinite;
	}

	@keyframes logo-text-rotate {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
}
</style>
